import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';

export const PageWrapper = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(0.75),
  display: 'flex',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
  backgroundColor: theme.palette.background.secondary,
  gap: theme.spacing(1),
  overflowY: 'auto',
}));

export const HalfPageContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  backgroundColor: theme.palette.background.secondary,
  gap: theme.spacing(0.75),
}));
